import React, { useEffect, useState,useRef} from "react";
import "./InvoiceScreen.css";
import { useNavigate } from "react-router-dom";
const DELIVERY_API = "/api/deliveries";
const INVOICE_API = "/api/invoices";
function numberToWords(num) {
  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  if (!num || num === 0) return "Zero";

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100)
      return b[Math.floor(n / 10)] + " " + a[n % 10];
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
    if (n < 10000000)
      return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);

    return "";
  }

  return inWords(Math.floor(num)).trim();
}

export default function InvoiceScreen({goHome}) {

  /* ================= STATE ================= */
  const [showPreview, setShowPreview] = useState(false);
const navigate = useNavigate();
const [mobileView, setMobileView] = useState("entry");
  const [pendingDeliveries, setPendingDeliveries] = useState([]);
  const [uniqueParties, setUniqueParties] = useState([]);

  const [partyDeliveries, setPartyDeliveries] = useState([]);
  const [rows, setRows] = useState([]);

  const [showPartyPopup, setShowPartyPopup] = useState(false);
  const [partySearch, setPartySearch] = useState("");
  const [search, setSearch] = useState("");

  const [isPrinting, setIsPrinting] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [viewInvoiceId, setViewInvoiceId] = useState(null);
  const [popupIndex, setPopupIndex] = useState(0);
  const newBtnRef = useRef(null);
const saveBtnRef = useRef(null);
const deleteBtnRef = useRef(null);
const printBtnRef = useRef(null);
const exitBtnRef = useRef(null);

const handleActionKeys = (e, current) => {
  if (e.key === "ArrowRight") {
    e.preventDefault();
    if (current === "new") saveBtnRef.current?.focus();
    if (current === "save") printBtnRef.current?.focus();
    if (current === "print") exitBtnRef.current?.focus();
  }

  if (e.key === "ArrowLeft") {
    e.preventDefault();
    if (current === "exit") printBtnRef.current?.focus();
    if (current === "print") saveBtnRef.current?.focus();
    if (current === "save") newBtnRef.current?.focus();
  }

  if (e.key === "Enter") {
    e.preventDefault();
    if (current === "new") resetForm();
    if (current === "save") handleSave();
    if (current === "delete") handleDelete();
    if (current === "print") printBtnRef.current?.click();
 if (current === "exit") goHome();
  }
};


  useEffect(() => {
  if (showPartyPopup) setPopupIndex(0);
}, [showPartyPopup, partySearch]);


const [header, setHeader] = useState({
  date: new Date().toISOString().slice(0, 10),
  invoiceNo: "",
  partyName: "",
  partyId: null,
  gstin: "",
  mobileNo: "",
  state: ""
});


  const [invoiceList, setInvoiceList] = useState([]);

  /* ================= INITIAL LOAD ================= */

  useEffect(() => {
    init();
  }, []);

async function init() {
    await autoGenerateInvoices(); // 🔥 auto-generate first
    await loadInvoiceList();
    await loadNextInvoiceNo();
}

async function autoGenerateInvoices() {
    try {
        await fetch(`${INVOICE_API}/auto-generate`, { method: "POST" });
    } catch (e) {
        console.error("Auto-generate failed", e);
    }
}
  /* ================= LOADERS ================= */

  async function loadPendingDeliveries() {
    const res = await fetch(`${DELIVERY_API}/pending`);
    const data = await res.json();
    setPendingDeliveries(Array.isArray(data) ? data : []);
  }

  useEffect(() => {
    const map = new Map();
    pendingDeliveries.forEach(d => {
      if (!map.has(d.partyName)) {
        map.set(d.partyName, {
          partyName: d.partyName,
          partyId: d.partyId || null
        });
      }
    });
    setUniqueParties(Array.from(map.values()));
  }, [pendingDeliveries]);

async function loadInvoiceList() {
  try {
    const res = await fetch(INVOICE_API); // 🔥 FULL invoice list
    if (!res.ok) throw new Error("Failed to load invoices");
    const data = await res.json();
    setInvoiceList(Array.isArray(data) ? data : []);
  } catch (e) {
    console.error(e);
    alert("Failed to load invoice list");
  }
}


  async function loadNextInvoiceNo() {
    const res = await fetch(`${INVOICE_API}/next-no`);
    const no = await res.json();
    setHeader(h => ({ ...h, invoiceNo: no }));
  }

  /* ================= MERGE ITEMS ================= */

  function mergeItems(deliveries) {
  if (!Array.isArray(deliveries)) return [];

  const map = {};

  deliveries.forEach(d => {
    (Array.isArray(d.items) ? d.items : []).forEach(it => {
      const key = `${it.itemName}|${it.rate}`;

      if (!map[key]) {
  map[key] = {
  itemName: it.itemName,
  hsnCode: it.hsnCode,
  taxPercent: it.taxPercent,
  qty: Number(it.qty),
  rate: Number(it.rate),
  amount: Number(it.amount),

  unitType: it.unitType || "",
  totalWeightGrams: Number(it.totalWeightGrams || 0)
};
      } else {
        map[key].qty += Number(it.qty);
        map[key].amount += Number(it.amount);
        map[key].totalWeightGrams += Number(it.totalWeightGrams || 0);
      }
    });
  });

  return Object.values(map);
}


  /* ================= LOAD PARTY DELIVERIES ================= */

 async function loadPartyDeliveries(partyName) {
  try {
    const res = await fetch(
      `${DELIVERY_API}/pending/by-party/${encodeURIComponent(partyName)}`
    );

    if (!res.ok) {
      throw new Error("Failed to load deliveries");
    }

    const deliveries = await res.json();

    // ✅ ALWAYS RESET FIRST
    setPartyDeliveries([]);
    setRows([]);

    // ✅ GUARD
    if (!Array.isArray(deliveries) || deliveries.length === 0) {
      setHeader(h => ({
        ...h,
        partyName,
        gstin: "",
       mobileNo: "",
        state: ""
      }));
      return;
    }

    const d0 = deliveries[0]; // ✅ SAFE NOW

setHeader(h => ({
  ...h,
  partyName,
  gstin:
    deliveries[0]?.gstNo && deliveries[0].gstNo.trim() !== ""
      ? deliveries[0].gstNo
      : "",
 mobileNo: deliveries[0]?.mobileNo || "",   // only if backend adds later
  state: deliveries[0]?.state || deliveries[0]?.address || ""
}));


    // ✅ DATA
    setPartyDeliveries(deliveries);
    setRows(mergeItems(deliveries));

  } catch (err) {
    console.error(err);
    alert("Failed to load party deliveries");

    // ✅ FAIL SAFE
    setPartyDeliveries([]);
    setRows([]);
    setHeader(h => ({
      ...h,
      gstin: "",
      mobileNo: "",
      state: ""
    }));
  }
}

  /* ================= TOTAL ================= */

 const total = Array.isArray(rows)
  ? rows.reduce((s, r) => s + Number(r.amount || 0), 0).toFixed(2)
  : "0.00";


  /* ================= SAVE ================= */

  async function handleSave() {
    if (!header.partyName || rows.length === 0) {
      alert("Select party");
      return;
    }

    if (partyDeliveries.length === 0) {
      alert("No pending deliveries");
      return;
    }

    const payload = {
      invoiceDate: header.date,
      partyName: header.partyName,
      deliveryIds: partyDeliveries.map(d => d.id)
    };

    const res = await fetch(INVOICE_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const err = await res.text();
      alert("Save failed: " + err);
      return;
    }

    alert("Invoice saved");

    resetForm();
    await loadPendingDeliveries();
    await loadInvoiceList();
    await loadNextInvoiceNo();
  }

 const filteredParties = uniqueParties.filter(p =>
  p.partyName.toLowerCase().includes(partySearch.toLowerCase())
);
useEffect(() => {
  if (!showPartyPopup) return;

  const handleKey = e => {
    if (!filteredParties.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setPopupIndex(i =>
          i < filteredParties.length - 1 ? i + 1 : i
        );
        break;

      case "ArrowUp":
        e.preventDefault();
        setPopupIndex(i => (i > 0 ? i - 1 : 0));
        break;

      case "Enter":
        e.preventDefault();
        const selected = filteredParties[popupIndex];
        if (selected) {
          setHeader(h => ({
            ...h,
            partyName: selected.partyName,
            partyId: selected.partyId
          }));
          setShowPartyPopup(false);
          setPartySearch("");
          loadPartyDeliveries(selected.partyName);
        }
        break;

      case "Escape":
        e.preventDefault();
        setShowPartyPopup(false);
        break;

      default:
        break;
    }
  };

  window.addEventListener("keydown", handleKey);
  return () => window.removeEventListener("keydown", handleKey);
}, [showPartyPopup, popupIndex, filteredParties]);
 

function resetForm() {
  setRows([]);
  setPartyDeliveries([]);
  setViewInvoiceId(null);

  setHeader({
    date: new Date().toISOString().slice(0, 10),
    invoiceNo: "",
    partyName: "",
    partyId: null,
    gstin: "",
    mobileNo: "",
    state: ""
  });
}



  async function loadInvoiceForEdit(invoiceId) {
  try {   setRows([]);
    setPartyDeliveries([]);

    if (!invoiceId) {
      alert("Invoice ID missing");
      return;
    }

    // ✅ CORRECT ENDPOINT
    const res = await fetch(`${INVOICE_API}/${invoiceId}`);

    if (!res.ok) throw new Error("Failed to load invoice");

    const inv = await res.json();
     setSelectedInvoiceId(invoiceId);
    // ✅ VERY IMPORTANT


    setHeader({
      date: inv.invoiceDate,
      invoiceNo: inv.invoiceNo,
      partyName: inv.partyName,
      partyId: inv.partyId || null,
      gstin: inv.deliveries?.[0]?.gstNo || "",
     mobileNo: "",
      state: inv.deliveries?.[0]?.address || ""
    });

    // ✅ FLATTEN delivery → items
    const items =
      inv.deliveries?.flatMap(d => d.items || []) || [];

setRows(mergeItems(inv.deliveries));
    setPartyDeliveries(inv.deliveries || []);

  } catch (err) {
    console.error(err);
    alert("Failed to load invoice");
  }
}

async function handleDelete() {
  if (!viewInvoiceId) return;

  if (!window.confirm("Delete this invoice?")) return;

  const res = await fetch(`${INVOICE_API}/${viewInvoiceId}`, {
    method: "DELETE"
  });

  if (!res.ok) {
    alert("Delete failed");
    return;
  }

  alert("Invoice deleted");

  resetForm();
  setViewInvoiceId(null);

  await loadInvoiceList();
  await loadNextInvoiceNo();
}



  /* ================= UI ================= */

  return (
    <>
      {/* ================= SCREEN UI ================= */}
      <div className={`inv-root show-${mobileView}`}>
        <div className="inv-title">INVOICE</div>

  <div className={`inv-content ${mobileView === "entry" ? "show-entry" : "show-list"}`}>
<div className="inv-mobile-bottom">

  <button
    className={mobileView === "list" ? "active" : ""}
    onClick={() => setMobileView("list")}
  >
    Invoice List
  </button>

  <button
    className={mobileView === "entry" ? "active" : ""}
    onClick={() => setMobileView("entry")}
  >
    Entry
  </button>

</div>

<button
className="mobile-add-btn"
onClick={()=>setMobileView("entry")}
>
+
</button>
          {/* LEFT */}
          <div className="inv-left">
            <div className="inv-card">

              <div className="inv-card-header">Invoice Entry</div>

              <div className="inv-header">
                <label>Date</label>
                <input
                  type="date"
                  value={header.date}
                  onChange={e =>
                    setHeader({ ...header, date: e.target.value })
                  }
                />

                <label>Invoice No</label>
                <input value={header.invoiceNo} disabled />

              <label>Party</label>
<input
  value={header.partyName}
  placeholder="Select from list →"
  readOnly
/>
              </div>
              <div className="inv-mobile-items">

{rows.map((r,i)=>(
<div key={i} className="inv-item-card">

<div className="item-row">
<label>Item</label>
<input value={r.itemName} readOnly />
</div>

<div className="item-row">
<label>Qty</label>
<input value={r.qty} readOnly />
</div>

<div className="item-row">
<label>U/A</label>
<input value={`${r.totalWeightGrams || ""} ${r.unitType || ""}`} readOnly />
</div>

<div className="item-row">
<label>Rate</label>
<input value={r.rate} readOnly />
</div>

<div className="item-row">
<label>Amount</label>
<input value={r.amount} readOnly />
</div>

</div>
))}

</div>

              
    <div className="inv-table-wrap">
  <table className="inv-table">
    <thead>
      <tr>
        <th>Item</th>
        <th>Qty</th>
        <th>U/A</th>
        <th>Rate</th>
        <th>Amount</th>
      </tr>
    </thead>
  </table>

  <div className="inv-table-body">
    <table className="inv-table">
      <tbody>
  {Array.from({ length: Math.max(4, rows.length) }).map((_, i) => {
    const r = rows[i];

    return (
      <tr key={i}>
        <td>{r ? r.itemName : ""}</td>
       <td>{r ? r.qty : ""}</td>

<td>
{r
  ? `${Number(r.totalWeightGrams || 0).toFixed(2)} ${r.unitType || ""}`
  : ""}
</td>
<td>{r ? r.rate : ""}</td>
<td>{r ? Number(r.amount).toFixed(2) : ""}</td>
      </tr>
    );
  })}
</tbody>

    </table>
  </div>
</div>


<div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field total">
      <label>Total</label>
      <input value={total}readOnly />
    </div>
</div>
</div>

 
<div className="inv-actions">
  <button
    ref={newBtnRef}
    onClick={resetForm}
    onKeyDown={e => handleActionKeys(e, "new")}
  >
    NEW
  </button>

  {viewInvoiceId && (
    <button
      ref={deleteBtnRef}
      className="danger"
      onClick={handleDelete}
      onKeyDown={e => handleActionKeys(e, "delete")}
    >
      DELETE
    </button>
  )}

  <button
    ref={printBtnRef}
    onClick={() => {
  if (!rows.length) return alert("No items to print");
  setPrintData({ deliveries: partyDeliveries, items: rows });
  setShowPreview(true);
}}
    onKeyDown={e => handleActionKeys(e, "print")}
  >
    PRINT
  </button>

  <button
    ref={exitBtnRef}
    onClick={goHome}
    onKeyDown={e => handleActionKeys(e, "exit")}
  >
    EXIT
  </button>
</div>


</div>



</div>
          {/* RIGHT */}
          <div className="inv-right">
            <div className="inv-right-title">Invoice List</div>

            <div className="del-search-row">
              <input
                className="del-search-input"
                placeholder="Search party..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>

            <div className="del-list">
  {invoiceList
  .filter(i =>
    i.partyName.toLowerCase().includes(search.toLowerCase())
  )
  .sort((a, b) =>
    a.partyName.localeCompare(b.partyName)
  )
  .map(i => (

  <div
    key={i.id}
    className="del-list-row"
onClick={async () => {

  console.log("Clicked invoice id:", i.id);

  setViewInvoiceId(i.id);
  await loadInvoiceForEdit(i.id);

  // MOBILE: switch to entry screen
if (window.innerWidth <= 768) {
  setMobileView("entry");
}

}}
  >

        <div className="del-list-top">
          <span className="del-list-dc">
            INV {i.invoiceNo}
          </span>
        </div>
        <div className="del-list-party">{i.partyName}</div>
        <div className="del-list-meta">
          ₹ {Number(i.totalAmount).toFixed(2)}
        </div>
      </div>
    ))}
</div>
</div>

        </div>
      </div>

     {(isPrinting || showPreview) && printData?.deliveries?.length > 0 && (() => {

  const billAmount = printData.items.reduce((s, it) => {
    const qty = Number(it.qty || 0);
    const rate = Number(it.rate || 0);
    const tax = qty * rate * (Number(it.taxPercent || 0) / 100);
    return s + qty * rate + tax;
  }, 0);

  const discount = 0;
  const totalTax = printData.items.reduce((s, it) => {
    const qty = Number(it.qty || 0);
    const rate = Number(it.rate || 0);
    const tp = Number(it.taxPercent || 0);
    return s + qty * rate * tp / 100;
  }, 0);

  const grandTotal = billAmount - discount;

  return (
    <div className={showPreview ? "preview-overlay" : "print-area"}>

      {showPreview && (
        <div className="preview-toolbar">
          <button className="preview-print-btn" onClick={() => {
            setShowPreview(false);
            setIsPrinting(true);
            setTimeout(() => {
              window.print();
              setIsPrinting(false);
              setPrintData(null);
            }, 100);
          }}>🖨️ PRINT</button>
          <button className="preview-close-btn" onClick={() => {
            setShowPreview(false);
            setPrintData(null);
          }}>✕ CLOSE</button>
        </div>
      )}

      <div className="bill-page">

        {/* ================= HEADER ================= */}
        <div className="bill-header">
          <div className="bill-header-top">
            <div className="bill-gstin">
              GSTIN : 33CLPWM2106A1ZG
            </div>
            <div className="bill-header-center">
              <div className="bill-title">ORANGE TRADINGS</div>
              <div className="bill-sub">
                (Naga Maida, Atta, Rava Whole Sale Dealer)<br />
                Dharapuram Road, Tiruppur – 641 608
              </div>
            </div>
            <div className="bill-phone">
              Cell : +91 8300045544<br />
              +91 9965647744
            </div>
          </div>
        </div>

        {/* ================= TO + INVOICE ================= */}
        <div className="bill-mid">
          <div className="bill-to">
            <b>To M/s :</b><br />
            {printData.deliveries[0].partyName}<br />
            Phone : {header.mobileNo !== "" ? header.mobileNo : "-"}<br />
            Gst No : {header.gstin !== "" ? header.gstin : "CUSTOMER"}
          </div>

          <div className="bill-invoice">
            <div className="bill-invoice-title">INVOICE</div>
            <div className="bill-invoice-customer">
              Customer Name : <b>{printData.deliveries[0].partyName}</b>
            </div>
            <table className="bill-invoice-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{header.invoiceNo}</td>
                  <td>{new Date(header.date).toLocaleDateString("en-GB")}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

       {/* ================= ITEMS ================= */}
{(() => {
 const partyGstin = printData?.gstin || header.gstin || "";
const partyStateCode = partyGstin.replace(/\s/g, "").substring(0, 2);
const OUR_STATE = "33";
const isIntraState =
  !partyGstin ||
  partyGstin === "CUSTOMER" ||
  partyStateCode === OUR_STATE;

const hasTax = printData.items.some(it => Number(it.taxPercent || 0) > 0);

  return (
    <table className="bill-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>PARTICULARS</th>
          <th>HSN</th>
          <th>QTY</th>
          <th>U/A</th>
          <th>RATE</th>
          {hasTax && isIntraState && <th>CGST</th>}
{hasTax && isIntraState && <th>SGST</th>}
{hasTax && <th>{isIntraState ? "TAX" : "IGST"}</th>}
          <th>AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {printData.items.map((it, i) => {
          const qty  = Number(it.qty  || 0);
          const rate = Number(it.rate || 0);
          const tp   = Number(it.taxPercent || 0);
          const tax  = qty * rate * tp / 100;
          const cgst = tax / 2;
          const sgst = tax / 2;
          const amt  = qty * rate + tax;

          return (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{it.itemName}</td>
              <td>{it.hsnCode}</td>
              <td className="num">{qty}</td>
              <td className="num">
                {Number(it.totalWeightGrams || 0).toFixed(2)} {it.unitType || ""}
              </td>
              <td className="num">{rate.toFixed(2)}</td>
            {hasTax && isIntraState && <td className="num">{cgst.toFixed(2)}</td>}
{hasTax && isIntraState && <td className="num">{sgst.toFixed(2)}</td>}
{hasTax && <td className="num">{tax.toFixed(2)}</td>}
              <td className="num">{amt.toFixed(2)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
})()}

     {/* ================= BILL BOX ================= */}
{(() => {
  const hasTax = printData.items.some(
    it => Number(it.taxPercent || 0) > 0
  );

  return (
    <div className="bill-bottom">
      <div className="bill-box">
        <div className="bill-box-left"></div>
        <div className="bill-box-right">
          <div>Discount : {discount.toFixed(2)}</div>
          {hasTax && <div>Tot Tax : {totalTax.toFixed(2)}</div>}
          <div>Bill Amnt : {billAmount.toFixed(2)}</div>
        </div>
      </div>

      <div className="bill-rupees-row">
        <div className="bill-rupees-text-left">
          Rupees : {numberToWords(grandTotal)} only.
        </div>
        <div className="bill-rupees-text-right">
          Total Amnt : {grandTotal.toFixed(2)}
        </div>
      </div>

      <div className="bill-footer">
        <div className="bill-footer-left">
          <ol>
            <li>We are not responsible for any loss or damage in transit.</li>
            <li>Please check quality and quantity before consumption.</li>
            <li>Payment after due date attracts interest @ 24% P.A.</li>
            <li>Subject to Tiruppur Jurisdiction.</li>
          </ol>
          <div className="bill-sign">
            Prepared By <span>Receivers Sign</span>
          </div>
        </div>
        <div className="bill-footer-right">
          <p>
            We hereby certify that the company registration under GST Act 2017
            is in force and this transaction is covered under this bill.
          </p>
          <div className="bill-auth">
            For <b>ORANGE TRADINGS</b><br />
            Authorised Signatory
          </div>
        </div>
      </div>
    </div>
  );
})()}

      </div>
    </div>
  );
})()}

    </>
  );
}
